<template>
  <div>
    <div class="d-flex flex-column text-center">
      <p v-if="seconds > 0">
        Vous allez être redirigé(e) automatiquement
        <br>
        <span class="fw-bold">
          dans {{ seconds }} seconde{{ seconds > 1 ? 's' : '' }}
        </span>
        <br>
        <slot>
          <span>vers la page de connexion.</span>
        </slot>
      </p>
      <div v-else>
        <div class="mt-3">
          Redirection en cours
          <span class="loader__dot">.</span>
          <span class="loader__dot">.</span>
          <span class="loader__dot">.</span>
        </div>
        <div
          class="spinner-border text-primary mx-auto my-3"
          style="width: 2rem; height: 2rem; border-width: thin;"
          role="status"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { debounce } from 'lodash-es';

import { defineComponent } from 'vue';

export default defineComponent({
  name: 'TimerHelper',
  props: {
    seconds: {
      type: Number,
      default: 15,
    },
  },
  data() {
    return {
      debouncer: ({ cancel: () => {} }),
    };
  },
  watch: {
    seconds: {
      handler(value) {
        if (value < -1) {
          this.redirectToDashboard();
        }
      },
    },
  },
  mounted() {
    if (this.seconds < 0) {
      this.redirectToDashboard();
    }
  },
  methods: {
    redirectToDashboard() {
      this.debouncer.cancel();
      const debouncerFunction = () => {
        this.$router.push('/login');
      };
      this.debouncer = debounce(debouncerFunction, 1500);
      this.debouncer();
    },
  },
});
</script>
